import React from 'react';
import { NextPage } from 'next';
import { Page as Component } from '~/components/specifics/deals/[id]/detail/Page';
import { NskHead } from '~/components/common/head/NskHead';

export const PATH = (id: number): string => `/deals/${id}/detail`;

const DealsDetail: NextPage = () => (
  <>
    <NskHead title="案件内容" />
    <Component />
  </>
);

export default DealsDetail;
